var destinationsText = vueIfExists({
	el: '#destinations-text',
	mixins: [win.toggleCollapse],
});